
import { useWindowSize, useThrottle } from '@vueuse/core'

export default defineNuxtPlugin((nuxtApp) => {
  // Stores

  // Helpers
  // Window Size - with fallback for SSR
  const { width, height } = useWindowSize({
    initialWidth: 1280,
    initialHeight: 720
  })
  
  const w = useThrottle(width, 150)
  const h = useThrottle(height, 150)

  // Provide
  return {
    provide: {
      viewport: {
        w,
        h,
      }
    },
  }
})
